import { render } from "./AposSlatList.vue?vue&type=template&id=9fe5d730&scoped=true"
import script from "./AposSlatList.vue?vue&type=script&lang=js"
export * from "./AposSlatList.vue?vue&type=script&lang=js"

import "./AposSlatList.vue?vue&type=style&index=0&id=9fe5d730&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fe5d730"],['__file',"ui/ui/apos/components/AposSlatList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9fe5d730"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9fe5d730', __exports__)) {
    api.reload('9fe5d730', __exports__)
  }
  
  module.hot.accept("./AposSlatList.vue?vue&type=template&id=9fe5d730&scoped=true", () => {
    api.rerender('9fe5d730', render)
  })

}


export default __exports__